import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { MenuFuncionService, MonedaService, ConversionMonedaService } from '../../../../src/app/shared/services/index';
import { ConversionMoneda, DialogConfirmRequest, DialogConfirmResponse, MenuFuncionCodes, Moneda, SaveConversionMoneda, SearchMonedaRequest } from '../../../../src/app/shared/model';
import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';

@Component({
  selector: 'app-monedaConversionEdit',
  templateUrl: './conversionEdit.component.html',
})
export class ConversionMonedaEditComponent implements OnInit {
  formGroup: FormGroup;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isSaving: boolean = false;
  isDeleting: boolean = false;
  isMonedaSearching: boolean = false;

  canEdit: boolean = false;
  canDelete: boolean = false;
  canAdd: boolean = false;
  canView: boolean = false;

  msgError: string = "";
  item: ConversionMoneda;

  monedas: Moneda[];

  constructor(
    private formBuilder: FormBuilder,
    private location: Location,
    public dialog: MatDialog,
    private sharedFunctions: SharedFunctions,
    private route: ActivatedRoute,
    private service: ConversionMonedaService,
    private monedaService: MonedaService,
    private menuService: MenuFuncionService
  ) { }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.MONEDA_CONVERSION).subscribe(data => {
      if (data != null && data.Success && data?.Result) {
        this.isValidating = false;
        this.canEdit = data.Result.some(x => x == MenuFuncionCodes.MONEDA_CONVERSION_EDIT);
        this.canAdd = data.Result.some(x => x == MenuFuncionCodes.MONEDA_CONVERSION_ADD);
        this.canView = data.Result.some(x => x == MenuFuncionCodes.MONEDA_CONVERSION_LIST);
        this.canDelete = data.Result.some(x => x == MenuFuncionCodes.MONEDA_CONVERSION_DELETE);
        this.loadView();
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.buildForm();
    this.getMonedas();

    this.loadEntity();
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      'FechaCotizacion': [new Date(), Validators.required],
      'MonedaOrigenId': [null, Validators.required],
      'MonedaDestinoId': [null, Validators.required],
      'ValorCompra': [null, Validators.required],
      'ValorVenta': [null, Validators.required],
      'Activo': [true, Validators.required]
    });
  }

  isProcessing() {
    return (this.isSearching || this.isSaving || this.isDeleting);
  }

  getMonedas() {
    var search = new SearchMonedaRequest(null, null, true, "Codigo", null, null, null, true);
    this.isMonedaSearching = true;

    this.monedaService.search(search).subscribe(data => {
      this.isMonedaSearching = false;
      this.monedas = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isMonedaSearching = false;
      this.sharedFunctions.showMessage(err?.error?.Message ?? "Ocurrió un error intentando ejecutar la operación", "Error");
    })
  }

  loadEntity() {
    this.route.params.subscribe(params => {
      if (params['id'] != null && params['id'] != '0') {
        var id = Number(params['id']);

        if (id > 0) {
          if(this.canView || this.canEdit){

            this.isSearching = true;
            this.service.get(id).subscribe(data => {
              this.isSearching = false;
              if (data != null && data.Success) {
                this.item = data.Result;

                if (this.item != null && this.item.Id > 0) {
                  this.formGroup.patchValue(this.item);
                }
                else
                this.msgError = "No se encontró el item seleccionado.";
              }
              else
              this.msgError = "Ocurrió un error al intentar obtener los datos del item.";
            },
            (err: HttpErrorResponse) => {
              this.isSearching = false;
              this.sharedFunctions.handleError(err, true);
            })
          }
          else {
            this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
            this.onCancel();
          }
        }
        else
          this.msgError = "Item no válido.";
      }
      else {
        if (this.canAdd) {
          this.item = new ConversionMoneda(0, new Date(), null, null, null, null, 0, 0, true, 0)
          this.formGroup.patchValue(this.item);
        }
        else {
          this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
          this.onCancel();
        }
      }
    });
  }

  getErrorMonedaOrigen() {
    return this.formGroup.get('MonedaOrigenId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorMonedaDestino() {
    return this.formGroup.get('MonedaDestinoId')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  getErrorValorCompra() {
    const control = this.formGroup.get('ValorCompra');

    if (control?.hasError('required')) {
      return 'El campo es obligatorio';
    }
    else if (control?.hasError('notGreaterThanZero')) {
      return 'El número debe ser mayor a cero';
    }
  }

  getErrorValorVenta() {
    const control = this.formGroup.get('ValorVenta');

    if (control?.hasError('required')) {
      return 'El campo es obligatorio';
    }
    else if (control?.hasError('notGreaterThanZero')) {
      return 'El número debe ser mayor a cero';
    }
  }

  getErrorFecha() {
    return this.formGroup.get('FechaCotizacion')?.hasError('required') ? 'El campo es obligatorio' : '';
  }

  onCancel() {
    this.location.back();
  }

  onGuardar() {

    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    var r = new SaveConversionMoneda(0, null, null, null, 0, 0, true);

    r =
    {
      ...this.formGroup.value,
      ...
      {
        Id: (this.item?.Id ?? 0),
        Activo: this.item.Activo
      }
    };

    this.isSaving = true;
    this.service.save(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
        this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
        this.onCancel();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onDelete() {
    if (!this.canDelete)
        return false;
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: new DialogConfirmRequest(null, "¿Está seguro que desea eliminar la conversión?", null, null)
    });
    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted) {
        this.isDeleting = true;
        this.service.delete(this.item.Id).subscribe(data => {
          this.isDeleting = false;
          if (data != null && data.Success && data.Result) {
            this.sharedFunctions.showMessage("Se eliminaron correctamente los datos!", "Operación Exitosa!");
            this.onCancel();
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isDeleting = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
    });
  }
}
